import React from 'react';
import styled from 'styled-components';
import { Flex } from './Common/Basic';
import { iconTypes, ProjectIcons } from './FontIcons';

const LoadingIcon = styled.span`
  color: #dddddd;
  transition: opacity 150ms ease-in-out;
`;

interface LoadingProps {
  small?: boolean;
  width?: string;
  height?: string;
}

const Loading: React.FC<LoadingProps> = ({ width = 80, height = 80 }) => (
  <Flex justifyContent="center" alignItems="center" width={1}>
    <LoadingIcon className="animate-spin">
      <ProjectIcons type={iconTypes.LOADING} color="#dddddd" width={width} height={height} />
    </LoadingIcon>
  </Flex>
);

export default Loading;
